import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { LoaderContainer } from '../components/atoms/LoaderContainer';
import useProductAvailability from '../hooks/useProductAvailability';

type Props = {
  redirect?: string;
};

const CasinoAccessGuard = ({ redirect = '/', children }: PropsWithChildren<Props>) => {
  const { hasCasinoAccess, isProductAvailabilityResolved } = useProductAvailability();

  if (!isProductAvailabilityResolved) {
    return <LoaderContainer />;
  }

  if (!hasCasinoAccess) {
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
};

export default CasinoAccessGuard;
